export enum PricingOption {
  monthlyBasic = 1,
  monthlyStandard,
  monthlyAdvanced,
  annualBasic,
  annualStandard,
  annualAdvanced,
  c2KeepPlus
}
